import React from 'react';

export default function FileUrlField({ value, onChange, mode, config, ...props }) {
    if (mode === "view") {
        return (
            <div>
                <span>{value}</span>
                {value && (
                    <a href={value} target="_blank" rel="noopener noreferrer" className="ms-2">
                        <i className="bi bi-box-arrow-up-right"></i>
                    </a>
                )}
            </div>
        );
    }
    
    return (
        <input 
            type="url" 
            value={value || ""} 
            onChange={e => onChange(e.target.value)} 
            className="form-control"
            placeholder="Enter file URL"
            {...props}
        />
    );
} 